import { rolesUsuario } from "./rolesUsers.constant"

type options = { [Key: string]: Readonly<string[]> }

export const permisosMenuUser: options = {
  //#region MENÚ REGISTROS
  REGISTROS: [
    rolesUsuario.ADMINISTRADOR,
    rolesUsuario.DOE,
    rolesUsuario.ARI,
    rolesUsuario.SECRETARIA,
    // rolesUsuario.CONSEJO_GENERAL,
    // rolesUsuario.OFICINA_AUXILIAR,
    // rolesUsuario.CONSEJERO,
  ],
  //#endregion

  //#region MENÚ MOVIMIENTOS
  MOVIMIENTOS: [
    rolesUsuario.ADMINISTRADOR,
    rolesUsuario.DOE,
    rolesUsuario.ARI,
    // rolesUsuario.CONSEJERO,
    // rolesUsuario.CONSEJO_GENERAL,
    // rolesUsuario.OFICINA_AUXILIAR,
  ],
  //#endregion

  //#region MENÚ REPORTES
  REPORTES: [
    rolesUsuario.ADMINISTRADOR,
    rolesUsuario.DOE,
    // rolesUsuario.ARI,
    // rolesUsuario.OFICINA_AUXILIAR,
  ],
  //#endregion

  //#region MENÚ IMPORTADOR
  IMPORTADOR: [
    rolesUsuario.ADMINISTRADOR,
    // rolesUsuario.DOE
  ],
  //#endregion

  // //#region MENÚ CALENDARIO
  // CALENDARIO: [
  //   rolesUsuario.ADMINISTRADOR,
  //   rolesUsuario.OFICINA_AUXILIAR,
  //   rolesUsuario.DOE,
  // ],
  // //#endregion

  // //#region MENÚ ENTREVISTAS
  // ENTREVISTAS: [
  //   rolesUsuario.ADMINISTRADOR,
  //   // rolesUsuario.CONSEJO_GENERAL,
  //   rolesUsuario.CONSEJERO,
  //   // rolesUsuario.DOE,
  // ],
  // //#endregion

  // //#region MENÚ ENTREVISTAS
  // CONSEJOS_ELECTORALES: [
  //   rolesUsuario.ADMINISTRADOR,
  //   // rolesUsuario.DOE,
  // ],
  // //#endregion

  // //#region MENÚ EXPEDIENTES
  // EXPEDIENTES: [
  //   rolesUsuario.ADMINISTRADOR,
  //   rolesUsuario.DOE,
  //   rolesUsuario.OFICINA_AUXILIAR,
  // ],
  // //#endregion

  // //#region MENÚ EXPEDIENTES
  // ADMINISTRACION: [rolesUsuario.ADMINISTRADOR],
  // //#endregion
} as const;
